import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '@lore/query-connect';
import CancelledTag from '@/pages/_components/CancelledTag';
import CompletedTag from '@/pages/_components/CompletedTag';
import ExpiredTag from '@/pages/_components/ExpiredTag';
import DateRange from './DateRange';
import Visibility from './Visibility';
import Creator from './Creator';
import Site from './Site';
import ShareLink from './ShareLink';
import PastProjectLink from './PastProjectLink';
import Partners from '@/pages/projects/Row/Partners';
import CreatorPhone from './CreatorPhone';
import CreatorEmail from './CreatorEmail';
import { useUser } from '@lore/auth';
import Network from '@/pages/projects/Project/Network';
import CancelledBanner from './CancelledBanner';
import { ProjectShareButton } from '@/features/share-project';

Header.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.number,
    data: PropTypes.shape({
      activityId: PropTypes.number,
      title: PropTypes.string,
      desiredOutcome: PropTypes.string
    })
  }).isRequired
};

export default function Header(props) {
  const { project } = props;

  const currentUser = useUser();

  const activity = useConnect('tag.byId', {
    id: project.data.activityId
  });

  return (
    <div className="flex flex-col space-y-6">
      <div className="space-y-2">
        <div className="flex space-x-4">
          <div className="text-sm text-gray-500">
            Project
          </div>
          <div className="flex space-x-2">
            <ExpiredTag resource={project} />
            <CancelledTag resource={project} />
            <CompletedTag resource={project} />
          </div>
        </div>
        <div className="text-3xl font-bold text-cs-gray-700">
          {project.data.title || activity.data.name || '...'}
        </div>
        <div className="text-cs-gray-500">
          {project.data.desiredOutcome}
        </div>
        <div className="flex justify-between">
          <div className="flex flex-wrap gap-x-4 gap-y-2">
            <DateRange project={project} />
            <Creator project={project} />
            <CreatorPhone project={project} />
            <CreatorEmail project={project} />
            <Site project={project} />
            {currentUser.data.isStaff && (
              <Network project={project} />
            )}
            <Visibility project={project} />
            <ShareLink project={project} />
            {currentUser.data.isStaff && (
              <PastProjectLink project={project} />
            )}
          </div>
          <div className="flex items-start gap-4 shrink-0">
            <ProjectShareButton project={project} />
            <Partners project={project} />
          </div>
        </div>
      </div>
      <CancelledBanner project={project} />
    </div>
  );
};
